var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlaycloseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29.999,
    viewBox: "0 0 30 29.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M17.748,15.136,29.43,3.454A1.943,1.943,0,0,0,26.682.706L15,12.387,3.318.706A1.943,1.943,0,1,0,.57,3.454L12.252,15.136.57,26.817a1.943,1.943,0,1,0,2.748,2.748L15,17.884,26.682,29.566a1.943,1.943,0,0,0,2.748-2.748Zm0,0",
    transform: "translate(0 -0.136)",
    fill: "rgba(248,225,247,0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlaycloseicon);
export default __webpack_public_path__ + "static/media/Overlay close icon.6a827b25b55ebff5caa7471187ff0587.svg";
export { ForwardRef as ReactComponent };